import { Schema } from 'effect';
import { Location3DSchema } from './location';
import { TimestampSchema } from './timestamp';

export const AircraftIdSchema = Schema.Number;
export type AircraftId = Schema.Schema.Type<typeof AircraftIdSchema>;

export const RiskVolume = {
  NOMINAL: 'nominal',
  GROUND_STOP: 'ground_stop',
  WELL_CLEAR: 'well_clear'
} as const;

export const RiskVolumeSchema = Schema.Literal(RiskVolume.NOMINAL, RiskVolume.GROUND_STOP, RiskVolume.WELL_CLEAR);

export type RiskVolume = Schema.Schema.Type<typeof RiskVolumeSchema>;

export const ForeignAircraftDetailsNotificationSchema = Schema.transform(
  Schema.Struct({
    aircraft_id: AircraftIdSchema,
    location: Location3DSchema,
    heading: Schema.optional(Schema.NullOr(Schema.Number)),
    timestamp: TimestampSchema,
    valid_until_timestamp: TimestampSchema
  }),
  Schema.Struct({
    aircraftId: AircraftIdSchema,
    location: Location3DSchema,
    heading: Schema.optional(Schema.NullOr(Schema.Number)),
    timestamp: Schema.String,
    validUntilTimestamp: Schema.String
  }),
  {
    strict: true,
    decode: (api) => ({
      aircraftId: api.aircraft_id,
      location: api.location,
      heading: api.heading,
      timestamp: api.timestamp,
      validUntilTimestamp: api.valid_until_timestamp
    }),
    encode: (client) => ({
      aircraft_id: client.aircraftId,
      location: client.location,
      heading: client.heading,
      timestamp: client.timestamp,
      valid_until_timestamp: client.validUntilTimestamp
    })
  }
);
export type ForeignAircraftDetailsNotification = Schema.Schema.Type<typeof ForeignAircraftDetailsNotificationSchema>;

export const ForeignAircraftRiskVolumeNotificationSchema = Schema.transform(
  Schema.Struct({
    aircraft_id: AircraftIdSchema,
    risk_volume: RiskVolumeSchema,
    timestamp: TimestampSchema,
    valid_until_timestamp: TimestampSchema
  }),
  Schema.Struct({
    aircraftId: AircraftIdSchema,
    riskVolume: RiskVolumeSchema,
    timestamp: Schema.String,
    validUntilTimestamp: Schema.String
  }),
  {
    strict: true,
    decode: (api) => ({
      aircraftId: api.aircraft_id,
      riskVolume: api.risk_volume,
      timestamp: api.timestamp,
      validUntilTimestamp: api.valid_until_timestamp
    }),
    encode: (client) => ({
      aircraft_id: client.aircraftId,
      risk_volume: client.riskVolume,
      timestamp: client.timestamp,
      valid_until_timestamp: client.validUntilTimestamp
    })
  }
);
export type ForeignAircraftRiskVolumeNotification = Schema.Schema.Type<
  typeof ForeignAircraftRiskVolumeNotificationSchema
>;
